import React from 'react';
import './membership-details.styles.scss';
import UnauthLayout from '@/components/layout-unauth/unauth-layout.component';
import PlanDetails from '../my-plan/plan-details.component';
import { Link } from 'react-router-dom';

const MembershipDetails = () => {
  return (
    <div className='membership-details'>
      <UnauthLayout>
        <div className='membership-details-content'>
          <div className='membership-card g-card'>
            <h1>Membership Details</h1>
            <div className='detail-content'>
              <p>Explore our membership plans and discover the perfect fit for you. View detailed information about each plan's features, benefits, and pricing to make an informed decision.</p>
              <Link to='/pricing' >
                <button className='g-button'>
                  Get Started
                </button>
              </Link>
            </div>
            <div className="g-space-1"></div>  
            <PlanDetails />
          </div>
        </div>
      </UnauthLayout>
    </div>
  )
};

export default MembershipDetails